/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type MarkDefragValueKnobsAsAcceptedMutationInput = {
    clientMutationId?: string | null | undefined;
    knobUrns: Array<UrnInput | null>;
    orgRelayId: string;
};
export type UrnInput = {
    id: string;
    scope?: UrnInput | null | undefined;
    type?: UrnType | null | undefined;
    value?: string | null | undefined;
};
export type MarkDefragValueKnobsAsAcceptedMutationVariables = {
    input: MarkDefragValueKnobsAsAcceptedMutationInput;
};
export type MarkDefragValueKnobsAsAcceptedMutationResponse = {
    readonly markDefragValueKnobsAsAccepted: {
        readonly clientMutationId: string | null;
    } | null;
};
export type MarkDefragValueKnobsAsAcceptedMutation = {
    readonly response: MarkDefragValueKnobsAsAcceptedMutationResponse;
    readonly variables: MarkDefragValueKnobsAsAcceptedMutationVariables;
};



/*
mutation MarkDefragValueKnobsAsAcceptedMutation(
  $input: MarkDefragValueKnobsAsAcceptedMutationInput!
) {
  markDefragValueKnobsAsAccepted(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "MarkDefragValueKnobsAsAcceptedMutationPayload",
            "kind": "LinkedField",
            "name": "markDefragValueKnobsAsAccepted",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "MarkDefragValueKnobsAsAcceptedMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "MarkDefragValueKnobsAsAcceptedMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "16ebcd7b6aedb47b0cb407cd67601278",
            "id": null,
            "metadata": {},
            "name": "MarkDefragValueKnobsAsAcceptedMutation",
            "operationKind": "mutation",
            "text": "mutation MarkDefragValueKnobsAsAcceptedMutation(\n  $input: MarkDefragValueKnobsAsAcceptedMutationInput!\n) {\n  markDefragValueKnobsAsAccepted(input: $input) {\n    clientMutationId\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '8b6d326709e3326adacedf592cb992bd';
export default node;
